import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Government organizations that fund, regulate, and oversee research initiatives',
    name: 'Federal Agencies',
    partialId: PartialId.Standard.create('fed_agencies'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
